import validator from 'validator';

import { INVALID_EMAIL, REQUIRED_FIELD } from 'utils/messages';

function loginValidation(data) {
  const errors = {};

  if (validator.isEmpty(data.email.trim())) errors.email = REQUIRED_FIELD;
  else if (!validator.isEmail(data.email)) errors.email = INVALID_EMAIL;
  if (validator.isEmpty(data.password.trim())) errors.password = REQUIRED_FIELD;

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default loginValidation;
